import { render, staticRenderFns } from "./productMask.vue?vue&type=template&id=0ec7bc11"
import script from "./productMask.vue?vue&type=script&lang=js"
export * from "./productMask.vue?vue&type=script&lang=js"
import style0 from "./productMask.vue?vue&type=style&index=0&id=0ec7bc11&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports